module.exports = __webpack_public_path__ + "img/carshina21_22.5a3b84b7.jpg";